export const userSelectorEnTranslations = {
  // Search and selection
  searchPlaceholder: 'Search for an employee',
  noEmployeesFound: 'No employees found matching your search',
  noEmployeesAvailable: 'No employees available',

  // Selection actions
  selectAll: 'Select all',
  clearAll: 'Clear all',
  allSelected: 'All selected',
  selectOptions: 'Select options',

  // Actions
  continue: 'Continue',

  // Validation messages
  pleaseSelectAtLeast: (count: number, type: string) =>
    `Please select at least ${count} ${type}`,
  employee: 'employee',

  // Selection count with proper pluralization
  selectionCount: (count: number) =>
    count === 1 ? `${count} employee selected` : `${count} employees selected`,

  // Assignees specific
  assigneesLabel: 'Assignees',
  assigneesDescription: 'Select employees to assign this goal to',
  selectAssignees: 'Select assignees',

  // Team member badge
  teamMember: 'Team Member',
};
